<header class="header-small" [ngStyle]="{'background-image': banner}">
  <div class="header-small__wrapper" *ngIf="!confirmationPage">
    <div class="header-small__top-container">
      <p class="header-small__label" (click)="backToShopPage()">Back to menu</p>
      <div class="header-top">
        <div>
          <div *ngIf="cartStore.tab && !cartStore.tab.is_closed" class="right-buttons">
            <div #tabsButton class="order" (click)="showOrdersInTab($event)">
              <p class="order__text">{{paymentStore.customer?.givenName}}'s tab</p>
            </div>
          </div>
        </div>
        <ion-menu-button></ion-menu-button>
      </div>
    </div>
    <div class="header-small__container">
      <div class="info" [class.info--no-logo]="!logo">
        <div *ngIf="logo.length !== 0" class="info__image-container"
          [ngClass]="isScrollStartPosition ? 'info__image-container--unshifted' : 'info__image-container--shifted'"
          (click)="navigateToHome()">
          <img [src]="logo" alt="Merchant logo" class="info__logo">
        </div>
        <p class="info__text" id="header-title">{{title}}</p>
        <!-- <p class="info__location" *ngIf="!isSubscriptionPage">Your order from {{displayName}}</p> -->
        <p class="info__location" *ngIf="isSubscriptionPage">{{paymentStore.customer?.givenName}}
          {{paymentStore.customer?.familyName}} • Since Today</p>
      </div>
    </div>
  </div>

  <div class="header-small__wrapper confirmation" *ngIf="confirmationPage">
    <ion-toolbar>
      <ion-title>{{title}}</ion-title>
    </ion-toolbar>
  </div>
</header>
